import PopupClass from './components/common/PopupClass';
import CatalogNavigationClass from "./components/common/CatalogNavigationClass";
import LoginFormClass from "./components/website/LoginFormClass";
import SignUpFormClass from "./components/website/SignUpFormClass";
import HubspotIntegrationClass from "./components/common/HubspotIntegrationClass";
import CatalogSearchClass from "./components/common/CatalogSearchClass";
// import TrialSurvey from "./components/lms/TrialSurvey";

import {
    CGSkills,
    videoPlayerTutorial
} from "./components/common/CoursePassingProcessClass";

// helpers
import {
    // smoothScrollToAnchor,
    showPassword
} from "./helpers/common-helpers";

import {
    stickyBreadcrumb,
    checkCoverImageIsExist,
    // priceSwitcher,
    progressBar,
    collapseCompletedModule,
    // redirectToSignup,
    closeSigninPopup,
    // learnMoreBtnHandler
} from "./components/common/Main";

import {
    // export all from sso
    // ssoSignUp,
    handleToken,
} from "./components/website/sso";
// import FormSendingClass from "./components/common/FormSendingClass";
import QuickReferencesDownloadClass from "./components/common/QuickReferencesDownloadClass";
import MainNav from "./components/website/MainNav";
import ToggleAccordion from "./components/website/ToggleAccordion";
import lottieAnimation from "./components/website/lottieAnimation";
// import SignUpHS from "./components/website/SignUpHS";
import DemoVideoHubspotSync from "./components/website/DemoVideoHubspotSync";
import clientsCarouselInit from "./components/website/clientsCarousel";
import loadVideo from "./components/website/loadVideo";

// initialize on DOMContentLoaded event
window.addEventListener('DOMContentLoaded', () => {
    // new TrialSurvey();
    new CatalogNavigationClass();
    new LoginFormClass();
    new SignUpFormClass();
    // smoothScrollToAnchor();
    CGSkills.openPopup();
    CGSkills.CGContentEvents();
    CGSkills.iDontKnowButton();
    CGSkills.notificationButtons();
    videoPlayerTutorial.init();
    stickyBreadcrumb();
    checkCoverImageIsExist();
    // priceSwitcher();
    progressBar();
    collapseCompletedModule();
    new HubspotIntegrationClass();
    // redirectToSignup();
    closeSigninPopup();
    // if(userData){
    //     if(sessionStorage.getItem('sso_signup')&&sessionStorage.getItem('sso_signup')==='true'){
    //         ssoSignUp();
    //         sessionStorage.setItem('sso_signup','false');
    //     }
    // }
    new CatalogSearchClass();
    handleToken();
    // new FormSendingClass();
    showPassword();
    new PopupClass();
    new QuickReferencesDownloadClass();
    // Form after online payment done
    // new SignUpHS();
    new MainNav();
    new ToggleAccordion();
    lottieAnimation();
    new DemoVideoHubspotSync();
    // learnMoreBtnHandler();
    clientsCarouselInit();
    loadVideo();
});
